/**
 * @generated SignedSource<<e459a41f083f9ca5cbcb6ae2084c0a03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ABTestForm_Query$variables = {};
export type ABTestForm_QueryVariables = ABTestForm_Query$variables;
export type ABTestForm_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ABTestDistributionSettingFields_root">;
};
export type ABTestForm_QueryResponse = ABTestForm_Query$data;
export type ABTestForm_Query = {
  variables: ABTestForm_QueryVariables;
  response: ABTestForm_Query$data;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestForm_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ABTestDistributionSettingFields_root"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ABTestForm_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceConnection",
        "kind": "LinkedField",
        "name": "sources",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Source",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f2d4a7142a9efa9a88bec252fdc47466",
    "id": null,
    "metadata": {},
    "name": "ABTestForm_Query",
    "operationKind": "query",
    "text": "query ABTestForm_Query {\n  ...ABTestDistributionSettingFields_root\n}\n\nfragment ABTestDistributionSettingFields_root on Query {\n  sources {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};

(node as any).hash = "01c8ab1e254a3737f4b9c7942a89b580";

export default node;
